// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,

  redirectUri: 'https://bienestar.junji.gob.cl/login',
  //redirectUri: 'http://localhost:4200/index',
  //redirectUri: 'https://bienestardesa2.junji.gob.cl/login',
  //redirectUri: 'https://bienestarcc-dev.azurewebsites.net/login',
  //urlBase: 'bienestar-cc-subsidio/v1'
  //urlBase: 'http://localhost:8080/bienestar-cc-subsidio/v1',
  //urlBase: 'https://apim-wso2.eastus2.cloudapp.azure.com:8243/bienestar-cc-subsidio/v1',
  //OLD
  clientId: 'c22a8e95-c55e-41ca-bbd4-4f7d17e01faa',//'c22a8e95-c55e-41ca-bbd4-4f7d17e01faa',//'2b75b8c3-3bb0-47fb-8d17-17de0983a886',
  authority: 'https://login.microsoftonline.com/f030ac7a-aa0b-4612-90a7-0d3d0de41a69',
  user:'extUser',
  pass:'$^-CBy',
  apiKey:'c43b4038-2c7f-407a-b1fe-49262eff6dc2',

  urlApiCargas:'https://loadbalancer01.junji.gob.cl/excelcarga/v1',
  urlApiCargaFamiliar:'https://loadbalancer01.junji.gob.cl/familiarcarga/v1',
  urlApiAyudaMedica:'https://loadbalancer01.junji.gob.cl/ayuda-medica/v1',
  urlApiUsuario:'https://loadbalancer01.junji.gob.cl/usuario/v1',
  urlApiSolicitudes:'https://loadbalancer01.junji.gob.cl/solicitudes/v1',
  urlApiOperacion:'https://loadbalancer01.junji.gob.cl/operacion/v1',
  urlApipagos:'https://loadbalancer01.junji.gob.cl/pago/v1',
  urlApiSubsidio:'https://loadbalancer01.junji.gob.cl/subsidio/v1',
  //urlBase: 'https://loadbalancer01.junji.gob.cl/bienestar/v1',
  urlBase:'https://loadbalancer01.junji.gob.cl/api-base-bienestar/v1',
  urlApiCoreservice:'  https://api-datosgenerales.junji.gob.cl/coreservice',
  urlApiClaveUnica: 'https://loadbalancer01.junji.gob.cl/claveUnica/v1',
  urlApiUpload: 'https://loadbalancer01.junji.gob.cl/uploader',
  urlApiAfiliacion: 'https://loadbalancer01.junji.gob.cl/afiliacion',
  urlApiPrestamo:'https://loadbalancer01.junji.gob.cl/prestamo/v1',
  urlIntegracion:'https://loadbalancer01.junji.gob.cl/integracion',

  urlBlob: 'https://stgaccpdevops01rec.azureedge.net/produccion',  
  apikey: 'eyJ4NXQiOiJOVGRtWmpNNFpEazNOalkwWXpjNU1tWm1PRGd3TVRFM01XWXdOREU1TVdSbFpEZzROemM0WkE9PSIsImtpZCI6ImdhdGV3YXlfY2VydGlmaWNhdGVfYWxpYXMiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJhZG1pbkBjYXJib24uc3VwZXIiLCJhcHBsaWNhdGlvbiI6eyJvd25lciI6ImFkbWluIiwidGllclF1b3RhVHlwZSI6bnVsbCwidGllciI6IlVubGltaXRlZCIsIm5hbWUiOiJhcHAtYmllbmVzdGFyLXN1YnNpZGlvcyIsImlkIjo0LCJ1dWlkIjoiM2YxYWMxODYtZTlkOC00YzY1LWJmYmQtMmVmZjMxZTE1NWYwIn0sImlzcyI6Imh0dHBzOlwvXC8xMC4zLjQuNjo5NDQzXC9vYXV0aDJcL3Rva2VuIiwidGllckluZm8iOnsiVW5saW1pdGVkIjp7InRpZXJRdW90YVR5cGUiOiJyZXF1ZXN0Q291bnQiLCJzdG9wT25RdW90YVJlYWNoIjp0cnVlLCJzcGlrZUFycmVzdExpbWl0IjowLCJzcGlrZUFycmVzdFVuaXQiOm51bGx9fSwia2V5dHlwZSI6IlNBTkRCT1giLCJzdWJzY3JpYmVkQVBJcyI6W3sic3Vic2NyaWJlclRlbmFudERvbWFpbiI6ImNhcmJvbi5zdXBlciIsIm5hbWUiOiJOb3RpZmljYXRpb25SRVNUQVBJIiwiY29udGV4dCI6Ilwvbm90aWZpY2F0aW9uXC92MSIsInB1Ymxpc2hlciI6ImFkbWluIiwidmVyc2lvbiI6InYxIiwic3Vic2NyaXB0aW9uVGllciI6IlVubGltaXRlZCJ9LHsic3Vic2NyaWJlclRlbmFudERvbWFpbiI6ImNhcmJvbi5zdXBlciIsIm5hbWUiOiJiaWVuZXN0YXItY2Mtc3Vic2lkaW8iLCJjb250ZXh0IjoiXC9iaWVuZXN0YXItY2Mtc3Vic2lkaW9cL3YxIiwicHVibGlzaGVyIjoiYWRtaW4iLCJ2ZXJzaW9uIjoidjEiLCJzdWJzY3JpcHRpb25UaWVyIjoiVW5saW1pdGVkIn1dLCJpYXQiOjE1OTQyNjkyMTgsImp0aSI6Ijg5ZjYzOGM1LWI3NjktNGIxZC04MDgwLTM0NzJiNjMxYzcyYiJ9.SB2F9-Zt9rzNWQKmVD3HcJ8ub2ZxyU94ieJu8_VFjAGBaXC2wRAFO4fKQeTsdemQTxs47O3jeKtKF0OeM7YtrsZzi4zS3D0fxUT7lYK8CE7R-woC6LxwqjLPaAn8jBDaXpJ7y3w7_V0vbD1jQZ-OzTWwHOe2EM867acQBBuH8zLl0i_YnPQkjkX90EE82gO0wAPeR7L2N4y8utxSHF409aeD1HWV3xOsa8OIMDnOxUXXTGjeW5lTjlw04cT80146DbtzQgC-KeWI531t_MO8T3WqXnVC12aFI2E41MMvTeLCe3chqLTTcQ2QVjjiqPhdAQDeoUGCvlIezxDiJHLeDQ==',

 //Integracion clave unica
 urlClaveUnica:'https://accounts.claveunica.gob.cl/',
 //urlClaveUnicaToken
 urlClaveUnicaToken:'https://accounts.claveunica.gob.cl/openid/token/',
 //Cliente Id entregado por claveunica
 clienteId:'75307209043c4f8ea213f03c65e2023c',
 //Client Secret entregado por claveunica
 clientSecret:'0c3f2d8b64354578ac5009f14975a296',
 //URL a la cual se debe redirigir cuando la autenticacion es exitosa
 claveRedirectUri:'https://bienestar.junji.gob.cl/aprobacion-solicitud-afiliacion',
 //url clave unica logout
urlClaveUnicaLogout:'https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.